import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-auction-disclaimer',
  templateUrl: './modal-auction-disclaimer.component.html',
  // styleUrls: ['./modal-auction-disclaimer.component.scss']
})
export class ModalAuctionDisclaimerComponent {
  constructor (public activeModal: NgbActiveModal) {}
}
